import {
  ClearButton,
  LoadingButton,
  Save as SaveIcon,
} from '@issuemanager/apps/client/components';
import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  formIsLoading: boolean;
  cleanForm: () => void;
  saveOrUpdate: () => void;
  mode: 'create' | 'update';
  hasChanged: boolean;
};

export function SLAPanelFooter(props: Props) {
  const { hasChanged, mode, cleanForm, formIsLoading, saveOrUpdate } = props;
  const { t } = useTranslation(['settings', 'common']);

  const saveBtnText = useMemo(() => {
    if (mode === 'create') {
      return formIsLoading
        ? t('settings:slaConfiguration.sidePanel.adding')
        : t('settings:slaConfiguration.sidePanel.add');
    } else {
      return formIsLoading
        ? t('settings:slaConfiguration.sidePanel.editing')
        : t('settings:slaConfiguration.sidePanel.edit');
    }
  }, [formIsLoading, mode]);

  return (
    <Stack flexDirection='row' justifyContent='space-between' flexGrow={2}>
      <Stack
        flexDirection='row'
        justifyContent='flex-start'
        flexGrow={1}
        gap={2}
      >
        <ClearButton
          onClick={cleanForm}
          aria-haspopup='true'
          disabled={formIsLoading}
        >
          {mode === 'update'
            ? t('settings:slaConfiguration.sidePanel.restore')
            : t('common:form.clear')}
        </ClearButton>
      </Stack>
      <Stack flexDirection='row' gap={2} flexGrow={2} justifyContent='flex-end'>
        <LoadingButton
          variant='contained'
          onClick={saveOrUpdate}
          aria-haspopup='true'
          loading={formIsLoading}
          disabled={mode === 'update' && !hasChanged}
          startIcon={<SaveIcon />}
        >
          {saveBtnText}
        </LoadingButton>
      </Stack>
    </Stack>
  );
}
